import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone } from "lucide-react";

export default function AdCard({ placement }) {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    api
      .get("/ads/serve", { params: { placement } })
      .then((r) => setAd(r.data?.ad || null))
      .catch(() => {});
  }, [placement]);

  if (!ad) return null;

  const open = () => {
    api.post(`/ads/click/${ad.campaign_id}`).catch(() => {});
    window.open(ad.link_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      data-testid={`ad-card-${placement}`}
      className="bg-white rounded-xl border border-brand-turquoise/40 p-4 flex items-start gap-3"
    >
      <div className="w-8 h-8 rounded-lg bg-brand-turquoise/15 flex items-center justify-center shrink-0">
        <Megaphone className="w-4 h-4 text-brand-turquoise" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Sponsorisé</span>
          {ad.advertiser && <span className="text-[10px] text-slate-400">· {ad.advertiser}</span>}
        </div>
        <p data-testid={`ad-title-${placement}`} className="font-semibold text-brand-navy text-sm mt-0.5">{ad.title}</p>
        <p className="text-xs text-slate-500 mt-0.5">{ad.body}</p>
        <button
          data-testid={`ad-cta-${placement}`}
          onClick={open}
          className="mt-2 text-xs font-semibold text-brand-blue hover:text-brand-navy hover:underline"
        >
          En savoir plus →
        </button>
      </div>
    </div>
  );
}
